/**
 * @generated SignedSource<<d09569255f24d0dbc1d6f5fe99e7b0d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateBulkBillToInput = {
  billTos?: ReadonlyArray<BillToBulkInputType | null> | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type BillToBulkInputType = {
  name: string;
  address: string;
  taxId: string;
  externalId: string;
  billFromId: string;
};
export type CreateBulkBillToMutation$variables = {
  input: CreateBulkBillToInput;
};
export type CreateBulkBillToMutation$data = {
  readonly createBulkBillTo: {
    readonly billTos: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
        readonly address: string;
        readonly externalId: string;
        readonly taxId: string;
        readonly billFromId: string;
      } | null;
    } | null> | null;
  } | null;
};
export type CreateBulkBillToMutation = {
  variables: CreateBulkBillToMutation$variables;
  response: CreateBulkBillToMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateBulkBillToPayload",
    "kind": "LinkedField",
    "name": "createBulkBillTo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "BillToTypeEdge",
        "kind": "LinkedField",
        "name": "billTos",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "BillTo",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "address",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "externalId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "taxId",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "billFromId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CreateBulkBillToMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CreateBulkBillToMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "116acb34ea3a3b428f7a8d934799ea40",
    "id": null,
    "metadata": {},
    "name": "CreateBulkBillToMutation",
    "operationKind": "mutation",
    "text": "mutation CreateBulkBillToMutation(\n  $input: CreateBulkBillToInput!\n) {\n  createBulkBillTo(input: $input) {\n    billTos {\n      node {\n        id\n        name\n        address\n        externalId\n        taxId\n        billFromId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "2a623a1a15a1c25e21ff13bf7716640d";

export default node;
